import { render, staticRenderFns } from "./OrganizationReliabilityReport.view.vue?vue&type=template&id=03caf6a6&"
import script from "./OrganizationReliabilityReport.view.vue?vue&type=script&lang=js&"
export * from "./OrganizationReliabilityReport.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03caf6a6')) {
      api.createRecord('03caf6a6', component.options)
    } else {
      api.reload('03caf6a6', component.options)
    }
    module.hot.accept("./OrganizationReliabilityReport.view.vue?vue&type=template&id=03caf6a6&", function () {
      api.rerender('03caf6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/client-space/supplier/organization-reliability-report/OrganizationReliabilityReport.view.vue"
export default component.exports